module.exports = __webpack_public_path__ + "img/Special-Projects.0b828751.png";